// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"f0186158","358":"e5066001","729":"0201fceb"}[chunkId] + ".chunk.js";
};